import script from "./Signup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Signup.vue?vue&type=script&setup=true&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=e1351250&lang=scss"
import "./Signup.vue?vue&type=style&index=1&id=e1351250&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1351250"]])

export default __exports__